module.exports = __webpack_public_path__ + "img/driver-empty-img4.68385d44.png";